<div class="eingesetzte-produkte-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <h2 mat-dialog-title>
      <mat-icon>inventory_2</mat-icon>
      {{ 'DIALOG.EINGESETZTE_PRODUKTE' | translate }}
    </h2>
    <button mat-icon-button (click)="closeDialog()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Dialog Content -->
  <mat-dialog-content class="dialog-content">
    <!-- Kontrolltermin Info -->
    <div class="info-card">
      <div class="info-grid">
        <div class="info-item">
          <strong>{{ 'DIALOG.ORDER_NUMBER' | translate }}:</strong>
          <span>#{{ kontrolltermin.einsatznummer }}</span>
        </div>
        <div class="info-item">
          <strong>{{ 'HEADER_INFO.LOCATION' | translate }}:</strong>
          <span>{{ kontrolltermin.standort?.name || ('COMMON.NOT_ASSIGNED' | translate) }}</span>
        </div>
        <div class="info-item">
          <strong>{{ 'HEADER_INFO.CLIENT' | translate }}:</strong>
          <span>{{ kontrolltermin.kunde?.suchbegriff || ('COMMON.NOT_ASSIGNED' | translate) }}</span>
        </div>
        <div class="info-item">
          <strong>{{ 'COMMON.DATE' | translate }}:</strong>
          <span>{{ formatDate(kontrolltermin.datum_durchfuerung) }}</span>
        </div>
      </div>
    </div>

    <!-- Products Summary Table -->
    <div class="table-card">
      <h3 class="table-title">
        <mat-icon>list</mat-icon>
        {{ 'DIALOG.PRODUCT_OVERVIEW' | translate }}
      </h3>

      <!-- Empty State -->
      <div *ngIf="produktSummary.length === 0" class="empty-state">
        <mat-icon>inventory_2</mat-icon>
        <p>{{ 'DIALOG.NO_PRODUCTS' | translate }}</p>
      </div>

      <!-- Products Table -->
      <div *ngIf="produktSummary.length > 0" class="table-container">
        <table mat-table [dataSource]="produktSummary" class="produkte-table">
          <!-- Produkt Column -->
          <ng-container matColumnDef="produkt">
            <th mat-header-cell *matHeaderCellDef>{{ 'DIALOG.PRODUCT' | translate }}</th>
            <td mat-cell *matCellDef="let produkt">
              <div>
                <strong>{{ produkt.name }}</strong>
                <div *ngIf="produkt.description" class="description">
                  {{ produkt.description }}
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Menge Column -->
          <ng-container matColumnDef="menge">
            <th mat-header-cell *matHeaderCellDef class="text-center">{{ 'DIALOG.QUANTITY' | translate }}</th>
            <td mat-cell *matCellDef="let produkt" class="text-center">
              <span class="badge badge-primary">{{ produkt.totalAmount }}</span>
            </td>
          </ng-container>

          <!-- Verwendet in Column -->
          <ng-container matColumnDef="verwendet">
            <th mat-header-cell *matHeaderCellDef>{{ 'DIALOG.USED_IN' | translate }}</th>
            <td mat-cell *matCellDef="let produkt" class="used-in-cell">
              <span *ngFor="let location of produkt.usedInIndicators; let last = last">
                {{ location }}<span *ngIf="!last">, </span>
              </span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
  </mat-dialog-content>

  <!-- Dialog Actions -->
  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button (click)="closeDialog()">{{ 'COMMON.CLOSE' | translate }}</button>
    <button 
      mat-raised-button 
      color="primary"
      (click)="printProdukte()"
      [disabled]="produktSummary.length === 0">
      <mat-icon>print</mat-icon>
      {{ 'DIALOG.PRINT' | translate }}
    </button>
  </mat-dialog-actions>
</div>

